module.exports = __webpack_public_path__ + "img/windows.22c616b7.svg";